import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { store } from './store';
import { AuthProvider } from './contexts/authContext';
import { ModalProvider } from './contexts/modal-context';
import App from './components/app/App';

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const { worker } = await import('./mocks/browser');
  // `onUnhandledRequest: 'bypass'` stops MSW from complaining about
  // actual unmocked requests (like loading images or fonts)
  return worker.start({ onUnhandledRequest: 'bypass' });
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <Provider store={store}>
      <AuthProvider>
        <ModalProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ModalProvider>
      </AuthProvider>
    </Provider>
  );
});
